import React from "react";
import Card from "../ui/Card";
import TapIcon from "../../../services/TapIcon";
import DateService from "../../../services/DateService";
import Loader from "../../../components/ui/Loader/Loader";
import Status from "../../../components/ui/Status";

const Documents = ({
  title,
  documents,
  loading,
  emptyMessage = "No records found",
}) => {
  if (loading) {
    return (
      <Card title={title}>
        <div className="text-center py-4">
          <Loader />
        </div>
      </Card>
    );
  }

  if (!documents || documents.length === 0) {
    return (
      <Card title={title}>
        <div className="text-center py-4 text-muted">
          {emptyMessage}
        </div>
      </Card>
    );
  }

  return (
    <Card title={title}>
      <div className="row mx-2 mt-3 border" style={{
              border: "1px solid #e0e0e0"
            }}>
        {documents.map((item, index) => (
          <div key={item.path || index} className="col-12 col-sm-6 ">
            <div>
              <div
                style={{
                  background: "#fff",
                  padding: "10px 12px",
                  height: "100%"
                }}
              >
                <div className="d-flex justify-content-between align-items-center pt-2"  style={{
                  background: "#f8f9fa",
                  gap: "8px"
                }}>
                  <span
                    style={{
                      fontSize: "13px",
                      wordBreak: "break-word",
                      flex: 1
                    }}
                  >
                    <span className="pe-2"><b>{index + 1}.</b></span>
                    {item.name && item.number ? `${item.name} (${item.number})` : item.name || "-"}
                  </span>

                  <span
                    className="text-primary"
                    onClick={() => window.open(item.path, "_blank")}
                    style={{
                      cursor: "pointer",
                      color: "#3CB5A0",
                      flexShrink: 0,
                      marginLeft: "10px"
                    }}
                  >
                    <TapIcon.FontAwesomeIcon icon={TapIcon.faEye} />
                  </span>
                </div>
              </div>

            </div>
          </div>
        ))}</div>

    </Card>
  );
};

export default Documents;